import "./sentryInit";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./styles/index.css";
import App from "./App";

function Fallback() {
  return (
    <div className="center-fill">
      <div className="card empty" style={{ maxWidth: 420 }}>
        <h3 style={{ fontSize: 20, fontWeight: 800, color: "var(--ink)" }}>Something went wrong</h3>
        <p style={{ margin: "6px 0 16px" }}>Please reload the page. If it keeps happening, let us know.</p>
        <button type="button" className="btn pri" data-testid="errorBoundary.reload" onClick={() => window.location.reload()}>Reload</button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
